import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Divider,Switch } from "antd"
import { ROLE_MANDU_SUPER_ADMIN } from "../../../../../utils/constants"
const SectionThreeSupport = (props) => {
  const { currentData } = props
  const { id_role } = props.currentData
  const checkUndefined = id_role == null
  const checkIfAdministratorMandu = checkUndefined
    ? false
    : currentData.adminDev?false:id_role === ROLE_MANDU_SUPER_ADMIN
  return (
    <div style={{ display: checkIfAdministratorMandu === false ? "none" : "block" }}>
      <Divider style={{ margin: "1rem -24px", width: "calc(100% + 48px)" }} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Switch
          checked={currentData.support}
          onChange={(checked) => props.setStateForm("support", checked)} />
        <h4 style={{ marginLeft: '8px', marginBottom: '0px' }}>Acceso a soporte</h4>
      </div>
      </div>
  )
}

SectionThreeSupport.propTypes = {
  currentData: PropTypes.object,
  form: PropTypes.object,
  setStateForm: PropTypes.func,
}

export default SectionThreeSupport
